import { render, staticRenderFns } from "./pay-rejected.vue?vue&type=template&id=220b3124&scoped=true"
import script from "./pay-rejected.vue?vue&type=script&lang=js"
export * from "./pay-rejected.vue?vue&type=script&lang=js"
import style0 from "./pay-rejected.vue?vue&type=style&index=0&id=220b3124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b3124",
  null
  
)

export default component.exports